<ng-content></ng-content>
<i
  class="fa-regular fa-circle-xmark soft-chip-icon"
  *ngIf="canDelete"
  (click)="delete.emit()"
>
</i>
